import { Accounting } from './accounting';
import { BoundBookEntry, DistributorConfig, DistributorInventoryProfile, FFL, Firearm } from './general';

export class Master {
    company_id?: string;
    company: CompanyInfo = new CompanyInfo();
    firearm_list: Firearm[] = [];
    ffl_list: FFL[] = [];
    bound_book: BoundBookEntry[] = [];
    accounting: Accounting = new Accounting();
}
export class EmailTemplates {
    subject: string = '';
    body: string = '';
    include_footer: boolean = false;
    include_ffl: boolean = false;
    include_sot: boolean = false;
}
export interface MongoId {
    $oid: string;
}

export class DocumentMeta {
    file_name: string | null = null;
    file_size_kb: number | null = null;
    uploaded_at: string | null = null;
}

export class CompanyInfo {
    _id?: MongoId;
    company_id: string;
    company_name: string | null = null;
    legal_name: string | null = null;
    ein?: string;
    company_logo: any | null = null;
    address: string | null = null;
    address2: string | null = null;
    city: string | null = null;
    state: string | null = null;
    zip_code: string | null = null;
    phone_number: string | null = null;
    company_email: string | null = null;
    customer_facing_email: string | null = null;
    website: string | null = null;
    ffl: string | null = null;
    ffl_expiration_date: string | null = null;
    users: User[] = [];
    change_log: CompanyChangeLog[] = [];
    payment_types: payment[] = [];
    ffl_document: string | null = null;
    sot_document: string | null = null;
    ffl_document_meta: DocumentMeta | null = null;
    sot_document_meta: DocumentMeta | null = null;
    autofill_form_3310: AutofillForm3310 = new AutofillForm3310();
    email_templates: Record<string, EmailTemplates> = {};
    live_inv_selected_distributors: DistributorInventoryProfile[] = [];
    distributor_configs: DistributorConfig[] = [];
    accounting_options: AccountingOptions = new AccountingOptions();
    onboarding_dismissed: boolean = false;
}
export class User {
    _id?: MongoId;
    user_id?: string
    company_id?: MongoId
    name_first: string
    name_last: string
    username: string
    password: string
    role: string
    position_title: string
    phone?: string
    email?: string
    signature?: string
}
export class CompanyChangeLog {
    change_date_time: string
    change_type: string
    change_to: string
    change_from: string
    change_by: string
}
export class payment {
    payment_type: string
    card_number: string
    card_exp_date: string
    card_cvv: string
    card_zip: string
    card_name: string
    billing_address: string
    billing_city: string
    billing_state: string
    billing_zip: string
    billing_country: string
    billing_phone: string
    bank_account_holder_name: string
    bank_account_type: string
    bank_account_number: string
    bank_routing_number: string
    status: string
}
export class loginAccount {
    id?: string
    email: string
    password: string
    company_id: string
    username?: string
    role?: string
    name_first?: string
    name_last?: string
    user_id?: string
    must_change_password?: boolean
}
export class AutofillForm3310 {
    agency_name: string | null = null;
    address: string | null = null;
    city: string | null = null;
    state: string | null = null;
    agency_email: string | null = null;
    atf_email: string | null = null;
}
export class AccountingOptions {
    costing_method_for_inventory: 'FIFO' | 'LIFO' | 'Average' | null = null;
    cash_accrual_basis: 'Cash Basis' | 'Accrual Basis' = 'Cash Basis';
    default_sales_receipt_message: string = '';
    default_message_on_sales_statement: string = '';
    custom_accounts: { type: 'Income' | 'Expense', name: string }[] = [];
    sales_tax_options: { name: string; state_rate: number; county_rate: number; city_rate: number; special_rate: number }[] = [];
    payment_accounts: string[] = [];
    payment_methods: string[] = ['ACH', 'Check', 'Credit Card', 'Cash', 'N/A'];
    credit_card_processing_rate: number = 0;
}